import { render, staticRenderFns } from "./instock.vue?vue&type=template&id=1819b769&"
import script from "./instock.vue?vue&type=script&lang=js&"
export * from "./instock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports